<template>
  <v-layout
    class="home-footer-info"
    id="current-client"
    justify-end
    align-center
    style="height: 100%"
  >
    <span>Weezie Fiber </span>
    <v-icon size="12" class="px-1"> copyright </v-icon>
    <span class="pr-4">{{ currentYear }}</span>
    <span v-if="client" style="padding-left: 2px;">
      {{ $t("LicensedTo") }} {{ client }}
    </span>
  </v-layout>
</template>

<script>
export default {
  name: "HomeFooterCurrentClient",

  computed: {
    client() {
      return localStorage.getItem("final_company_name") || localStorage.getItem("company_name")
    },

    currentYear() {
      let today = new Date();
      return today.getFullYear();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Footer/CurrentClient.vue